import React, { useRef } from 'react';

import Slider from 'react-slick';
import '../styles//OurProductsSection.css';
import { Link } from 'react-router-dom';

// Sample product images (replace with actual imports)
import Semiconductor_Product1 from '../assets/Our_Product1.png';
import Semiconductor_Product2 from '../assets/Our_Product2.png';
import Semiconductor_Product3 from '../assets/product2.png';
import Semiconductor_Product4 from '../assets/product1.png';


const products = [
  { title: "Code Reader", subtitle: "Our Projects", link: "/products/CodeReader", img: Semiconductor_Product1 },
  { title: "AI Image Recognition", subtitle: "Our Projects", link: "/products/VisionSensor", img: Semiconductor_Product2 },
  { title: "Process sensors / Fluid sensors", subtitle: "Our Projects", link: "/ProcessFluidSensors", img: Semiconductor_Product3 },
  { title: "Position sensors", subtitle: "Our Projects", link: "/PositionSensor", img: Semiconductor_Product4 },
];

const sliderSettings = {
  dots: false,
  infinite: true,
  speed: 1000,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  arrows: false, // default slick arrows removed
  responsive: [
    { breakpoint: 992, settings: { slidesToShow: 2 } },
    { breakpoint: 600, settings: { slidesToShow: 1 } },
  ]
};

const OurProductsSection = () => {
  const sliderRef = useRef();

  return (
    <div className="product-slider-section">
      <h2 className="slider-title">Our Products</h2>
      <div className="slider-bar"></div>

<Slider ref={sliderRef} {...sliderSettings} className="product-slider">
  {products.map((item, index) => (
    <div className="product-card" key={index}>
      <Link to={item.link}>
        <img src={item.img} alt={item.title} />
        <div className="product-overlay">
          <div className="product-text">
            <h3>{item.title}</h3>
            <p>{item.subtitle}</p>
          </div>
        </div>
      </Link>
    </div>
  ))}
</Slider>

<div className="slider-arrows">
  <button className="slider-arrow prev" onClick={() => sliderRef.current?.slickPrev()}>
    &#8249;
  </button>
  <button className="slider-arrow next" onClick={() => sliderRef.current?.slickNext()}>
    &#8250;
  </button>
</div>

    </div>
  );
};

export default OurProductsSection;
